import { useUser } from "@/context/user";
import { getRoutes } from "@/utils/helpers";
import storage from "@/utils/storage";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const isAuthenticated = useUser((state) => state.isAuthenticated);
  const vid = storage.getItem("vid");

  const routes = getRoutes();

  return isAuthenticated || vid ? (
    <Navigate to={routes.dashboard} replace />
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
